import React from "react"
import { useColors } from "@mallardbay/lib-react-components"

import ResponsiveBlock from "~components/shared/responsive-block"
import type { AddressFieldsFragment } from "~graphql/generated/graphql"
import { ListingType } from "~graphql/generated/graphql"
import { formatCityStateAndCountry } from "~utils/formatting-helpers"
import PageSectionHeading from "~components/shared/typography/page-section-heading"
import TripMap from "~components/shared/trip-map/trip-map"
import COPY from "~config/copy-constants"
import { TEST_IDS } from "~config/test-ids"
import {
    TextExtraSmall,
    Text,
} from "~components/shared/todo-lib-react-components/text"
import AspectRatio from "~components/shared/todo-lib-react-components/aspect-ratio"
import Box from "~components/shared/todo-lib-react-components/box"

interface Props {
    readonly type?: ListingType | null
    readonly location?: AddressFieldsFragment | null
}

export default function ListingLocation({ type, location }: Props) {
    const normalizedType = type ?? ListingType.BlastCast

    const styles = useStyles()

    const displayLocation = formatCityStateAndCountry(location)

    return (
        <ResponsiveBlock testId={TEST_IDS.LISTING_MAP_CONTAINER}>
            <Box style={styles.root}>
                <PageSectionHeading
                    style={styles.heading}
                    label={COPY.LOCATION}
                />
                <AspectRatio ratio={16 / 9}>
                    <Box style={styles.mapContainer}>
                        <TripMap location={location} type={normalizedType} />
                    </Box>
                </AspectRatio>
                <Text style={styles.location}>{displayLocation}</Text>
                <TextExtraSmall>
                    {COPY.EXACT_LOCATION_PROVIDED_AFTER_BOOKING}
                </TextExtraSmall>
            </Box>
        </ResponsiveBlock>
    )
}

function useStyles() {
    const colors = useColors()

    const root = {
        color: colors.text,
    }

    const heading = {
        marginBottom: 4,
    }

    const location = {
        marginTop: 4,
    }

    const mapContainer = {
        borderRadius: "16px",
        overflow: "hidden",
    }

    return {
        root,
        heading,
        location,
        mapContainer,
    }
}
